import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import Error from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { SubscriptionStripe } from 'crono-fe-common/types/subscriptionStripe';

export default function useGetSubscription(enabled = true) {
  return useQuery<Response<SubscriptionStripe>, Error>({
    queryKey: [ENDPOINTS.subscription.manager],
    queryFn: () => {
      const request: Request = {
        url: `${ENDPOINTS.subscription.manager}`,
        config: {
          method: 'get',
        },
      };
      return client(request);
    },
    enabled,
    staleTime: Infinity,
  });
}
